<template>

    <!-- Input -->
    <div
      class="search-input"
      :class="{'open': showSearchBar}"
    >
      <div class="search-input-icon" style="padding:10px"  @click="closeSearch(); resetsearchQuery(); reiniciarSearch()">

        
        <feather-icon  icon="ArrowLeftIcon" />
      </div>
      <!-- <input type="text" placeholder="Explore Vuexy...." class="form-control-input"> -->
      <!-- @keyup.esc="escPressed" -->
      <!-- @keyup.enter="suggestionSelected" -->
      <b-form-input
      ref="searchInput"
        v-if="showSearchBar"
        v-model="searchQuery"
        placeholder="Buscar ..."
        autofocus
        autocomplete="off"
        @keyup.up="increaseIndex(false)"
        @keyup.down="increaseIndex"
        @keyup.esc="closeSearch(); resetsearchQuery(); reiniciarSearch()"
        @keyup.enter="suggestionSelected"
        
      />
      <div
        class="search-input-close"
       
      >


<div style="cursor:pointer;margin-right: 20px;   display: inline-block !important;"  @click="clear">
  <feather-icon icon="XIcon"  class="hide_clear" :class="{'show_clear': searchQuery}"/>
      
</div>




<div v-if="isMicro"  @click="openMicro" style=" cursor:pointer;   display: inline-block !important;">
  <b-avatar

        size="35"
        variant="light-primary"
        >

        <span class="d-flex align-items-center">
          <feather-icon  icon="MicIcon" class="color_icon" />



        </span>

        </b-avatar>
</div>

  
       
      </div>

    

      <div
      class="search-list search-list-main scroll-area overflow-hidden"
      :class="{'show': !searchQuery}"
      @click="closeSearch(); resetsearchQuery(); reiniciarSearch()"
      >
      <b-row>

        <b-col cols="12" sm="12" md="12" lg="12" xl="12" >

          <p style="text-align: center; color:white;font-weight: bold;font-size:16px; margin-bottom:25px; margin-top:15px">Búsquedas más populares</p>

          </b-col>
          <b-col   @click="closeSearch(); resetsearchQuery(); reiniciarSearch()"  cols="6" sm="6" md="3" lg="4" xl="2" >

        <b-link     :to="{ name: 'perfil', hash: '#general'}" >

  
                      <b-card class="hover_div">
                      <b-row>

                      <b-col style="text-align: center;" cols="12" sm="3" md="3" lg="3" xl="3">

                        <feather-icon
                                      icon="EditIcon"
                                      size="21"
                                      class="color_icon"
                                      />
                 


                      </b-col>

                      <b-col  cols="12" sm="9" md="9" lg="9" xl="9" style="display:flex">

          
                    <p  style="text-align: center !important;font-size: 12px;margin:auto" class="txt_display2">
                                    Edición de perfil
                                  </p>


                    </b-col>

                        

                        </b-row>
                        </b-card>

                    

        </b-link>

        </b-col>

        <b-col   @click="closeSearch(); resetsearchQuery(); reiniciarSearch()"  cols="6" sm="6" md="3" lg="4" xl="2" >
          <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#tarjetas'}"  >
                                    <b-card class="hover_div">
                                    <b-row>

                                    <b-col style="text-align: center;" cols="12" sm="3" md="3" lg="3" xl="3">

                                      <feather-icon
                                                    icon="CreditCardIcon"
                                                    size="21"
                                                    class="color_icon"
                                                    />



                                    </b-col>

                                    <b-col  cols="12" sm="9" md="9" lg="9" xl="9" style="display:flex">


                                    <p  style="text-align: center !important;font-size: 12px;margin:auto;" class="txt_display2">
                                                Gestión de tarjetas
                                                </p>


                                    </b-col>

                                      

                                      </b-row>
                                      </b-card>

                                      </b-link>
       
      </b-col>

      

      <b-col   @click="closeSearch(); resetsearchQuery(); reiniciarSearch()"  cols="6" sm="6" md="3" lg="4" xl="2" >

        
<b-link   style="width: 100%;" :to="{ name: 'recargar'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="3" md="3" lg="3" xl="3">
   <svg width="21" class="icons_colors" height="21"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 612.006 612.006" style="enable-background:new 0 0 612.006 612.006"><g><g><path d="M482.288 437.042c-45.521.0-82.42 36.899-82.42 82.426.0 45.514 36.906 82.414 82.42 82.414 45.521.0 82.414-36.899 82.414-82.414C564.702 473.947 527.809 437.042 482.288 437.042zM482.288 583.58c-35.412.0-64.112-28.7-64.112-64.112.0-35.412 28.7-64.118 64.112-64.118 35.406.0 64.118 28.707 64.118 64.118C546.407 554.88 517.694 583.58 482.288 583.58z"/><path d="M0 262.212h126.044V10.124H0V262.212zM62.385 36.234c18.547.0 33.578 15.05 33.578 33.584.0 18.541-15.031 33.578-33.578 33.578-18.541.0-33.578-15.037-33.578-33.578C28.807 51.284 43.838 36.234 62.385 36.234z"/><path d="M465.55 355.825c0 0-3.372 19.934 10.859 24.352.0.0 15.157 2.836 19.039-10.821l5.691-83.454c.592-8.363-3.933-14.942-3.933-14.942-1.683-2.445-3.655-4.878-5.729-7.266-7.72-3.775-17.192-8.124-28.089-12.567 1.33 1.733 2.653 3.561 3.901 5.451.0.0 5.489 9.346 4.487 18.447L465.55 355.825z"/><path d="M524.437 397.155c0 0 5.199.945 11.092-.851 1.947-23.406 6.075-69.406 9.983-90.411.0.0 3.183-17.602-16.297-28.618.0.0-9.806-5.943-26.81-14.01 2.597 2.83 5.048 5.779 7.096 8.729.0.0 4.752 6.794 4.134 15.428l-6.101 87.834C507.535 375.261 507.39 394.47 524.437 397.155z"/><path d="M573.141 202.493C440.177 81.333 329.933 49.627 329.933 49.627c-24.982-7.273-59.014-7.985-59.014-7.985H157.555V180.29h50.689c53.499 119.742 135.062 183.224 135.062 183.224 23.999 18.881 54.684 45.256 54.684 45.256 21.642 19.675 29.501 17.98 29.501 17.98 17.318.0 16.789-21.698 16.789-21.698.0-39.332-62.94-104.478-62.94-104.478-11.804-13.644-.265-29.948-.265-29.948 19.94-24.913 41.311-34.517 41.311-34.517 8.458-4.714 27.144-.794 27.144-.794 55.863 10.626 97.041 38.683 97.041 38.683 12.85 8.13 11.602 25.688 11.602 25.688-3.542 21.245-8.521 76.799-8.521 76.799-2.54 32.267 15.535 34.278 15.535 34.278 45.439 5.275 46.819-129.428 46.819-129.428C612 231.754 573.141 202.493 573.141 202.493z"/><path d="M508.014 519.827c-2.672-1.739-5.697-3.057-9.081-3.964-3.384-.907-6.813-1.639-10.279-2.193v-18.32c7.317.328 15.22 1.872 23.703 4.62v-16.342c-3.479-1.21-7.279-2.162-11.439-2.855-4.153-.681-8.243-1.147-12.258-1.361v-8.256h-13.127v8.508c-4.449.492-8.464 1.374-12.006 2.647-3.548 1.26-6.561 2.924-9.037 4.985-2.477 2.073-4.38 4.512-5.697 7.355-1.323 2.836-1.985 6.069-1.985 9.699.0 4.456.851 8.092 2.565 10.903 1.702 2.798 3.926 5.061 6.649 6.768 2.723 1.708 5.792 2.987 9.201 3.838 3.416.851 6.85 1.525 10.317 2.01v18.094c-2.798-.063-5.388-.214-7.752-.46-2.37-.246-4.626-.58-6.775-.989-2.136-.416-4.235-.908-6.277-1.494-2.023-.574-4.115-1.242-6.271-2.017v16.184c3.145 1.431 7.09 2.534 11.854 3.334 4.764.807 9.838 1.286 15.226 1.45v8.086h13.127v-8.502c9.081-.989 16.083-3.491 21.012-7.506 4.922-4.015 7.386-9.554 7.386-16.6.0-4.405-.838-8.004-2.515-10.815C512.86 523.829 510.68 521.56 508.014 519.827zM475.526 511.609c-3.573-.655-6.239-1.601-8.01-2.811-1.752-1.21-2.634-2.975-2.634-5.281.0-2.029.769-3.725 2.307-5.073 1.544-1.355 4.33-2.244 8.331-2.685v15.85H475.526zM488.653 545.376v-15.522c3.466.611 6.05 1.506 7.72 2.685 1.683 1.185 2.515 2.93 2.515 5.237C498.888 541.961 495.479 544.488 488.653 545.376z"/></g></g><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>

  </b-col>
  <b-col  cols="12" sm="9" md="9" lg="9" xl="9" style="display:flex">

   <p  style="text-align: center !important;font-size: 12px;margin:auto;" class="txt_display2">
    Recargas de billetera
                                                </p>
 
</b-col>



  

  </b-row>
  </b-card>

   </b-link>

        </b-col>

        <b-col   @click="closeSearch(); resetsearchQuery(); reiniciarSearch()"  cols="6" sm="6" md="3" lg="4" xl="2" >

          <b-link   style="width: 100%;" :to="{ name: 'retiros'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="3" md="3" lg="3" xl="3">
  <svg width="21" class="icons_colors" height="21" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path  d="M8 0l2 3H9v2H7V3H6l2-3z"/><path  d="M15 7v8H1V7h14zm1-1H0v10h16V6z"/><path  d="M8 8c1.657.0 3 1.343 3 3s-1.343 3-3 3h5v-1h1V9h-1V8H8z"/><path  d="M5 11c0-1.657 1.343-3 3-3H3v1H2v4h1v1h5c-1.657.0-3-1.343-3-3z"/></svg>
  
</b-col>

    <b-col  cols="12" sm="9" md="9" lg="9" xl="9" style="display:flex">

<p  style="text-align: center !important;font-size: 12px;margin:auto;" class="txt_display2">
  Retiros de dinero
                                             </p>

</b-col>


  

  </b-row>
  </b-card>

   </b-link>
        </b-col>


        <b-col   @click="closeSearch(); resetsearchQuery(); reiniciarSearch()"  cols="6" sm="6" md="3" lg="4" xl="2" >

          <b-link   style="width: 100%;" :to="{ name: 'remesas'}"  >
            <b-card class="hover_div">
            <b-row>

            <b-col style="text-align: center;" cols="12" sm="3" md="3" lg="3" xl="3">

              <svg width="21" class="icons_colors" height="21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 945.5 945.5" style="enable-background:new 0 0 945.5 945.5"><g><g><path d="M255.1 457.399c126.3.0 228.7-102.399 228.7-228.7C483.799 102.4 381.4.0 255.1.0 128.8.0 26.4 102.4 26.4 228.7 26.4 355 128.8 457.399 255.1 457.399zM160.7 124.5c0-12.4 10.1-22.5 22.5-22.5h50V71.7c0-12.4 10.1-22.5 22.5-22.5s22.5 10.1 22.5 22.5v30.4h43.5c12.4.0 22.5 10.1 22.5 22.5.0 12.4-10.1 22.5-22.5 22.5h-43.4v59.1h47.8c12.399.0 22.5 10.1 22.5 22.5v104.1c0 12.4-10.101 22.5-22.5 22.5h-47.8v30.4c0 12.399-10.1 22.5-22.5 22.5s-22.5-10.101-22.5-22.5v-30.4h-47.7c-12.4.0-22.5-10.1-22.5-22.5s10.1-22.5 22.5-22.5h47.7v-59.1h-50c-12.4.0-22.5-10.1-22.5-22.5V124.5H160.7z"/><path d="M205.7 147h27.5v59.1H205.7z"/><path d="M278.2 251.2h25.3v59.1H278.2z"/><path d="M919.1 716.8c0-126.3-102.4-228.7-228.7-228.7S461.6 590.5 461.6 716.8 564 945.5 690.299 945.5C816.6 945.5 919.1 843.1 919.1 716.8zM786.2 648.3c0 12.4-10.1 22.5-22.5 22.5s-22.5-10.1-22.5-22.5v-15.9h-97.8V660.2h46.3c12.4.0 22.5 10.1 22.5 22.5.0 12.399-10.1 22.5-22.5 22.5h-46.3v17.6h46.3c12.4.0 22.5 10.1 22.5 22.5s-10.2 22.5-22.6 22.5h-46.301v27.9H741.1v-15.2c0-12.4 10.1-22.5 22.5-22.5 12.399.0 22.5 10.1 22.5 22.5v37.7c0 12.399-10.101 22.5-22.5 22.5H620.799c-12.399.0-22.5-10.101-22.5-22.5v-50.4h-14.8c-12.399.0-22.5-10.1-22.5-22.5s10.101-22.5 22.5-22.5h14.8v-17.6h-14.8c-12.399.0-22.5-10.101-22.5-22.5.0-12.4 10.101-22.5 22.5-22.5h14.8v-50.301c0-12.399 10.101-22.5 22.5-22.5h142.9c12.4.0 22.5 10.101 22.5 22.5V648.3z"/><path d="M639.4 391.399l42.7 61.9c4 5.8 12.5 5.8 16.5.0l42.699-61.9c4.601-6.6-.199-15.7-8.199-15.7h-12.5c-3.7-38.3-13.301-72.1-28.601-100.8-16.8-31.6-40.2-57-69.7-75.5-32.899-20.6-65.899-27.8-85.1-30.3-8.9-1.2-16.8 5.8-16.9 14.8l-.1 30.3c0 7.4 5.4 13.7 12.7 14.9 13.8 2.1 37 7.7 59.5 22.4 38.399 25 61.1 66.7 67.8 124.2h-12.5C639.6 375.7 634.9 384.7 639.4 391.399z"/><path d="M209.3 578.3h12.5c3.7 38.3 13.3 72.1 28.6 100.8 16.8 31.601 40.2 57 69.7 75.5 32.899 20.601 65.899 27.8 85.1 30.3 8.9 1.2 16.8-5.8 16.9-14.8l.1-30.3c0-7.4-5.4-13.7-12.7-14.9C395.6 722.8 372.4 717.2 350 702.5c-38.399-25-61.1-66.7-67.8-124.2h12.5c8.1.0 12.8-9 8.2-15.7l-42.7-61.8c-4-5.8-12.5-5.8-16.5.0L201 562.7C196.5 569.3 201.2 578.3 209.3 578.3z"/></g></g><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>




            </b-col>
            <b-col  cols="12" sm="9" md="9" lg="9" xl="9" style="display:flex">

<p  style="text-align: center !important;font-size: 12px;margin:auto;" class="txt_display2">
  Envios de remesas
                                             </p>

</b-col>

              

              </b-row>
              </b-card>

              </b-link>
        </b-col>

        <b-col   @click="closeSearch(); resetsearchQuery(); reiniciarSearch()"  cols="6" sm="6" md="3" lg="4" xl="2" >

          <b-link   style="width: 100%;" :to="{ name: 'wallets'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="3" md="3" lg="3" xl="3">

  <svg width="21" class="color_icon" height="21" viewBox="0 0 1034 1034" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="currentcolor" d="M497 177q-95 1-179.5 41.5T173 330q-62 75-85 169-28 112 4 222 31 107 111 185 82 80 194 108t222-4q107-32 185-111 80-82 108-194t-4-223q-32-106-111-184-82-81-194-108-53-14-106-13zM483 325l46 12-19 75 38 8 18-74 47 11-19 77q49 17 72 40 27 28 21 67-8 57-59 69 33 17 44 43 13 29-1 70-18 50-62 64-37 11-103-1l-19 77-47-12 19-76-37-9-19 76-47-11 20-78-94-24 23-53 17 5q17 4 17 3 15 4 21-11l31-122 5 1-5-1 21-88q2-21-21-27l-34-8v0l12-50 65 16h-1l30 8zm15 142-23 93 7 2q41 11 64 10 41 0 49-32t-27-51q-19-11-61-20zM463 607l-26 102 9 3q50 13 77 13 49 0 58-35t-34-57q-23-12-73-24z" /></svg>
  



 </b-col>

 <b-col  cols="12" sm="9" md="9" lg="9" xl="9" style="display:flex">

<p  style="text-align: center !important;font-size: 12px;margin:auto;" class="txt_display2">
  Criptomonedas
                                             </p>

</b-col>

  

  </b-row>
  </b-card>

   </b-link>

        </b-col>

      </b-row>
  
    </div>


      <!-- Suggestions List -->
      <div
        class="search-list search-list-main scroll-area overflow-hidden"
        :class="{'show': searchQuery}"
        @click="closeSearch(); resetsearchQuery(); reiniciarSearch()"
      >
      
        <li
          v-for="(suggestion_list, grp_name, grp_index) in filteredData"
          :key="grp_index"
          class="suggestions-groups-list"
        >

          <!-- Group Header -->


          <!-- Suggestion List of each group -->
          <ul>
            <li
              v-for="(suggestion, index) in suggestion_list"
              :key="index"
              class="suggestion-group-suggestion cursor-pointer"
              :class="{'suggestion-current-selected': currentSelected === `${grp_index}.${index}`}"
              @mouseenter="currentSelected = `${grp_index}.${index}`"
              @mousedown.prevent="suggestionSelected(grp_name, suggestion)"
            >
              <b-link
                v-if="grp_name === 'Resultados'"
                class="p-0"
              >
                <feather-icon
                  :icon="suggestion.icon"
                  class="mr-75"
                />
                <span class="align-middle">{{ suggestion.title }}</span>
              </b-link>
            </li>

            <li
              v-if="!suggestion_list.length && searchQuery"
              class="suggestion-group-suggestion no-results"
            >
            <div align="center">
              <svg width="300" height="300" viewBox="-20 0 190 190"  xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.155 140.475 48.988 62.1108l43.881 4.946 18.568 23.955-8.041 57.1092L38.155 140.475zM84.013 94.0018 88.827 71.8068l-34.781-3.5-9.854 67.1502L98.335 142.084l6.542-45.2752-20.864-2.807zM59.771 123.595C59.394 123.099 56.05 120.299 55.421 119.433 64.32 109.522 86.05 109.645 92.085 122.757 91.08 123.128 86.59 125.072 85.71 125.567 83.192 118.25 68.445 115.942 59.771 123.595zM76.503 96.4988 72.837 99.2588l-5.515-6.642L59.815 96.6468l-3.029-5.069L63.615 88.1508l-4.526-5.452L64.589 79.0188 68.979 85.4578 76.798 81.5328 79.154 86.2638l-7.047 3.783 4.396 6.452z" fill="#fff"/></svg>
            </div>
              <p style="text-align:center; color:white; font-weight: bold;font-size:16px">No se encontraron resultados.</p>
            </li>
          </ul>
        </li>
      </div>
      <b-modal
                ref="modalMicrofono"
                centered
                hide-footer
                hideHeaderClose
                hideHeader
                size="sm"
                @hidden="closeModalMicro"
              >
                <div class="d-block text-center" style="padding:15px">

                  <b-row v-if="hasPermiso">

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12"> 

                    <p style="font-weight: bold; font-size:16px; text-align: left;margin-bottom:20px">Escuchando....</p>

                    </b-col>

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12"> 

                      <p>{{ transcript }}</p>

                    </b-col>

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" align="center" style="margin-top:75px; margin-bottom:40px">
                      <div class="box">
                          <div class="object">
                              <div class="outline">
                              </div>
                              <div class="outline" id="delayed">
                              </div>
                              <div class="button">
                              </div>
                              <div class="button" id="circlein">
                                <svg class="mic-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve" style="fill:#fff">
                        <g><path d="M500,683.8c84.6,0,153.1-68.6,153.1-153.1V163.1C653.1,78.6,584.6,10,500,10c-84.6,0-153.1,68.6-153.1,153.1v367.5C346.9,615.2,415.4,683.8,500,683.8z M714.4,438.8v91.9C714.4,649,618.4,745,500,745c-118.4,0-214.4-96-214.4-214.4v-91.9h-61.3v91.9c0,141.9,107.2,258.7,245,273.9v124.2H346.9V990h306.3v-61.3H530.6V804.5c137.8-15.2,245-132.1,245-273.9v-91.9H714.4z"/></g>
                        </svg>
                              </div>
                          </div>
                        </div>

                           
                    </b-col>

              
                  </b-row>


                  <b-row v-else>

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12"> 

                      <p style="font-weight: bold; font-size:18px; text-align: left;margin-bottom: 15px">Esperando permiso</p>
                      <p style=" font-size:14px; text-align: left;">Otorga permiso a EQCoop para acceder a tu micrófono y comienzes a realizar búsquedas con la voz.</p>

                     
                    
                    
                    
                    </b-col>


                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" align="center" style="margin-top:25px">
                      <b-avatar
                              size="55"
                              variant="light-primary"
                              style="cursor:pointer;background:#c00 !important">

                              <span class="d-flex align-items-center">


                                <feather-icon
                              icon="MicIcon"
                              size="30"
                              class="color_icon_micro"
                            />

                              </span>

                              </b-avatar>

                              <p style="text-align: center;font-size:10px">Micrófono deshabilitado</p>
                    </b-col>

             

                   
                 
                  </b-row>
          
          
                      

                          
                         

                            </div>

              </b-modal>
    </div>

</template>

<script>
import {
  BFormInput, BLink, BImg, BAvatar,BCard, BRow, BCol
} from 'bootstrap-vue'
import { ref, watch } from 'vue'
import useAutoSuggest from '@core/components/app-auto-suggest/useAutoSuggest'
import { title } from '@core/utils/filter'
import router from '@/router'
import store from '@/store'
import searchAndBookmarkData from '../search-and-bookmark-data'

export default {
  components: {
    BFormInput,
    BCol,
    BRow,
    BLink,
    BCard,
    BImg,
    BAvatar,
  },
  setup() {
    const showSearchBar = ref(false)



    const suggestionSelected = (grpName, suggestion) => {
      // If parameter is not provided => Use current selected
      if (!suggestion) {
        // If currentSelected value is -1 => No value/item is selected (Prevent Errors)
        /* eslint-disable no-use-before-define, no-param-reassign */
        if (currentSelected.value !== -1) {
          /* eslint-disable no-use-before-define, no-param-reassign */
          const [grpIndex, itemIndex] = currentSelected.value.split('.')
          grpName = Object.keys(filteredData.value)[grpIndex]
          suggestion = filteredData.value[grpName][itemIndex]
          /* eslint-enable */
        }
      }
      if (grpName === 'Resultados') router.push(suggestion.route).catch(() => {})
      // eslint-disable-next-line no-use-before-define
      this.reiniciarSearch()
      resetsearchQuery()
      showSearchBar.value = false
    }

    const {
      searchQuery,
      reiniciarSearch,
      resetsearchQuery,
      filteredData,
    } = useAutoSuggest({ data: searchAndBookmarkData, searchLimit: 10 })

    watch(searchQuery, val => {


      //store.commit('app/TOGGLE_OVERLAY', Boolean(val))
    })



    const currentSelected = ref(-1)
    watch(filteredData, val => {
      if (!Object.values(val).some(obj => obj.length)) {
        currentSelected.value = -1
      } else {
        // Auto Select first item if it's not item-404
        let grpIndex = null

        // eslint-disable-next-line no-restricted-syntax
        for (const [index, grpSuggestions] of Object.values(val).entries()) {
          if (grpSuggestions.length) {
            grpIndex = index
            break
          }
        }

        if (grpIndex !== null) currentSelected.value = `${grpIndex}.0`
      }
    })

    const increaseIndex = (val = true) => {
      /* eslint-disable no-lonely-if, no-plusplus */

      // If there's no matching items
      if (!Object.values(filteredData.value).some(grpItems => grpItems.length)) return

      const [grpIndex, itemIndex] = currentSelected.value.split('.')

      const grpArr = Object.entries(filteredData.value)
      const activeGrpTotalItems = grpArr[grpIndex][1].length

      if (val) {
        // If active item is not of last item in grp
        if (activeGrpTotalItems - 1 > itemIndex) {
          currentSelected.value = `${grpIndex}.${Number(itemIndex) + 1}`

        // If active item grp is not last in grp list
        } else if (grpIndex < grpArr.length - 1) {
          for (let i = Number(grpIndex) + 1; i < grpArr.length; i++) {
            // If navigating group have items => Then move in that group
            if (grpArr[i][1].length > 0) {
              currentSelected.value = `${Number(i)}.0`
              break
            }
          }
        }
      } else {
        // If active item is not of first item in grp
        if (Number(itemIndex)) {
          currentSelected.value = `${grpIndex}.${Number(itemIndex) - 1}`

        // If active item grp  is not first in grp list
        } else if (Number(grpIndex)) {
          for (let i = Number(grpIndex) - 1; i >= 0; i--) {
            // If navigating group have items => Then move in that group
            if (grpArr[i][1].length > 0) {
              currentSelected.value = `${i}.${grpArr[i][1].length - 1}`
              break
            }
          }
        }
      }
      /* eslint-enable no-lonely-if, no-plusplus */
    }

    let userAgentString =  navigator.userAgent;

  


    let transcript = ref('')
    let isRecording = ref(false)
    let isMicro = ref(false)
    let hasPermiso = ref(false)
    let sr = ref('')


     // Detect Chrome
     let chromeAgent =  userAgentString.indexOf("Chrome") > -1;
          
            // Detect EDGE
            let edgeAgent =  userAgentString.indexOf("Edg") > -1;
     
     
            // Detect Safari
            let safariAgent =  userAgentString.indexOf("Safari") > -1;
                  
            // Discard Safari since it also matches Chrome
            if ((chromeAgent) && (safariAgent)) 
                safariAgent = false;
          
            // Detect Opera
            let operaAgent =  userAgentString.indexOf("OP") > -1;
                  
            // Discard Chrome since it also matches Opera     
            if ((chromeAgent) && (operaAgent)) 
                chromeAgent = false;

      if(chromeAgent || safariAgent || edgeAgent){
        isMicro=true;
      }else{
        isMicro=false;
      }


  
     if(isMicro){
    

      const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition  

         sr = new Recognition()

         sr.lang = 'es-ES';

     }

  
    return {
      showSearchBar,
      searchAndBookmarkData,
      title,
      suggestionSelected,
      currentSelected,
      increaseIndex,
      transcript,
      isRecording,
      sr,
      isMicro,
      hasPermiso,
      body: document.getElementsByTagName('body')[0],
      // AutoSuggest
      searchQuery,
      reiniciarSearch,
      resetsearchQuery,
      filteredData,
    }
  },        watch: {

    showSearchBar(newValue) {

      this.body.classList.add("overflow-hidden");

      



      },

    },mounted(){

    this.showSearchBar = true;
       store.commit('app/TOGGLE_OVERLAY', true)

    if(this.isMicro){

      this.sr.continuous = true
      this.sr.interimResults = true

      this.sr.onstart = () => {
   
        this.transcript=null;
        this.hasPermiso=true;
        this.isRecording = true
      }

      /*

      this.sr.onaudioend = () => {
        console.log('onaudioend executed')

      }

      this.sr.onspeechend = () => {
        console.log('onspeechend executed')

      }

      */

      

      this.sr.onerror = (event) => {

        this.$refs.modalMicrofono.hide();


      if(event.error === "not-allowed"){
       

        this.$toast.error("Tiene bloqueado el acceso al microfono en este navegador. Otorgue permiso de acceder al micrófono e intente nuevamente." , {
                      position: 'top-right',
                      timeout: 3010,
                      closeOnClick: true,
                      pauseOnFocusLoss: false,
                      pauseOnHover: true,
                      draggable: true,
                      draggablePercent: 0.4,
                      showCloseButtonOnHover: false,
                      hideProgressBar: true,
                      closeButton: 'button',
                      icon: true,
                      rtl: false,
                    })

      }else{

        if(event.error === "network"){
        

          this.$toast.error("Navegador no compatible. Utilize el navegador Chrome, Edge o Safari e inténtelo de nuevo." , {
                      position: 'top-right',
                      timeout: 3010,
                      closeOnClick: true,
                      pauseOnFocusLoss: false,
                      pauseOnHover: true,
                      draggable: true,
                      draggablePercent: 0.4,
                      showCloseButtonOnHover: false,
                      hideProgressBar: true,
                      closeButton: 'button',
                      icon: true,
                      rtl: false,
                    })

        }

      }



      }


      

      

      this.sr.onend = () => {

        this.isRecording = false;
        this.$refs.modalMicrofono.hide();

      }

      this.sr.onresult = (evt) => {
        for (let i = 0; i < evt.results.length; i++) {
          const result = evt.results[i]

          if (result.isFinal){
     
            this.sr.stop();
            this.$refs.modalMicrofono.hide();

          }
        }

        const t = Array.from(evt.results)
          .map(result => result[0])
          .map(result => result.transcript)
          .join('')

     
        this.transcript = t
        this.searchQuery=this.transcript.replace(/\./g,'');
    
      }

    }

  

  },
  methods: {

    

    reiniciarSearch(){
      this.$eventBus.$emit('reiniciarSearchBar')
    },

    closeModalMicro(){
      this.sr.stop();
    },

    clear(){
      
      this.$refs.searchInput.focus();
      this.searchQuery = '';

    },

    closeSearch(){
      this.body.classList.remove("overflow-hidden");
      this.showSearchBar = false

    },

    openMicro(){

    
         this.$refs.modalMicrofono.show();

         if (this.isRecording) {
          this.sr.stop()
        } else {
          this.sr.start()
        }

    },

    close(){
      // eslint-disable-next-line no-use-before-define
     
  
      setTimeout(() => this.closeSearch(), 100);
 

      
     
    },

  }
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

ul
{
  list-style: none;
  padding: 0;
  margin: 0;
}
p {
  margin: 0;
}

.hide_clear{
  display:none;
}



/* .app-auto-suggest {
  position: relative;
}

.auto-suggest-suggestions-list {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  border-radius: 6px;
  position: absolute;
  top: calc(100% + 1rem);
  background-color: white;
  width: 100%;
} */

.suggestion-group-title {
  font-weight: 500;
  padding: .75rem 1rem .25rem;
}

.suggestion-group-suggestion {
  padding: .75rem 1rem
}


.suggestion-current-selected {
  background-color: $body-bg;
  


  .dark-layout & {
    background-color: $theme-dark-body-bg;
  }
}
</style>
